<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-4">
          Update Custom Notification
        </p>
        <v-form v-model="isFormValid">
          <CustomNotificationEditor
            v-if="dialog"
            ref="customNotificationEditor"
            :params="params"
            @updateData="updateData($event)"
          ></CustomNotificationEditor>
        </v-form>
        <v-card-actions class="pt-6">
          <v-btn color="error" :disabled="!isFormValid" @click="deleteNotif"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!isFormValid" @click="clickFinish"
            >Save</v-btn
          >
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import CustomNotificationEditor from './CustomNotificationEditor.vue'

export default {
  components: {
    CustomNotificationEditor
  },
  data() {
    return {
      loading: true,
      dialog: false,
      options: {
        color: 'primary',
        width: 650,
        zIndex: 200
      },
      isFormValid: false,
      notificationId: -1,
      params: {},
      dataFromChild: {}
    }
  },
  methods: {
    open(params) {
      this.params = params
      this.loading = false
      this.dialog = true
      this.notificationId = params.notificationId
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    updateData(data) {
      this.dataFromChild = data
    },
    async fetchEditorData() {
      this.$refs.customNotificationEditor.emitData()
    },
    async clickFinish() {
      await this.fetchEditorData()
      await this.$root
        .$confirm({
          title: 'Update Custom Notification',
          message: `Are you sure you would like to update the notification?`
        })
        .then(() => {
          this.finish()
        })
    },
    async finish() {
      try {
        this.loading = true
        const success = await this.$store.dispatch(
          'notifications/updateNotificationsAction',
          {
            title: this.dataFromChild.title,
            categories: this.dataFromChild.categories,
            type: this.dataFromChild.type,
            frequency: this.dataFromChild.frequency,
            emailMessage: this.dataFromChild.emailMessage,
            smsMessage: this.dataFromChild.smsMessage,
            notificationId: this.notificationId,
            attachSOA: this.dataFromChild.attachSOA,
            bccPropertyEmail: this.dataFromChild.bccPropertyEmail,
            inactive: this.dataFromChild.inactive
          }
        )

        this.loading = false
        this.dialog = false
        // this.$router.go()
        if (success) {
          this.$root.$confirm({
            title: 'Update Notification',
            message: `The notification has been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
        }
        await this.$store.dispatch('notifications/fetchNotificationsAction')
      } catch (err) {
        this.$root
          .$confirm({
            title: 'Update Custom Notification Error',
            message: err,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'error'
            }
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
    },
    async deleteNotif() {
      const confirm = await this.$root.$confirm({
        title: 'Delete Notification',
        message: `Are you sure you would like to delete the notification "${this.params.title}"`,
        confirmText: 'OK',
        options: {
          color: 'error'
        }
      })

      if (confirm) {
        const success = await this.$store.dispatch(
          'notifications/deleteNotificationAction',
          {
            notificationId: this.params.notificationId
          }
        )

        if (success) {
          this.$root.$confirm({
            title: 'Delete Notification',
            message: `The notification has been deleted.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
        }
        this.dialog = false
        await this.$store.dispatch('notifications/fetchNotificationsAction')
      }
    }
  }
}
</script>

<style>
p {
  margin-bottom: 0 !important;
}
</style>
